/** @format */

import {styled} from '@mui/material/styles';
import {FormControl, Select, MenuItem, Box} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import {SelectMenuProps} from './types';

export const MENU_PROPS: SelectMenuProps = {
  PaperProps: {
    style: {
      width: 250,
      backgroundColor: '#3C3C3C',
      borderRadius: '8px',
      border: '1px solid #4A4A4A',
      marginTop: '4px',
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

export const StyledFormControl = styled(FormControl)(() => ({
  '& .MuiInputLabel-root': {
    color: '#888888',
    '&.Mui-focused': {
      color: '#4A4A4A',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

export const StyledSelect = styled(Select)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  height: '32px',
  borderRadius: '8px',
  fontSize: '14px',
  border: `1px solid ${theme.palette.figma_surface_muted?.main}`,

  '&:hover': {
    borderColor: theme.palette.figma_primary?.main,
  },

  '&:active': {
    borderColor: theme.palette.figma_primary?.light,
  },

  '&.Mui-disabled': {
    borderColor: theme.palette.figma_gray_dark_4?.main,

    '& .MuiSelect-select': {
      '-webkit-text-fill-color': `${theme.palette.figma_surface_muted?.main} !important`,
    },
  },

  '& .MuiSelect-select': {
    padding: theme.spacing(3, 4),
    paddingRight: '40px !important',
    display: 'flex',
    alignItems: 'center',
    minHeight: 'unset',
    color: theme.palette.text.primary,
  },

  '& .MuiSelect-icon': {
    color: '#888888',
    right: '12px',
    fontSize: '20px',
  },
}));

export const StyledPlaceholderMenuItem = styled(MenuItem)(() => ({
  color: '#888888 !important',
}));

export const StyledMenuItemText = styled(Box)(() => ({
  marginLeft: '8px',
  flexGrow: 1,
}));

export const StyledMenuItem = {
  backgroundColor: 'transparent !important',
  color: '#FFFFFF !important',
  fontSize: '14px !important',
  minHeight: '40px !important',
  padding: '8px 16px !important',
  whiteSpace: 'normal !important',
  '&:hover': {
    backgroundColor: '#4A4A4A !important',
  },
  '&.Mui-selected': {
    backgroundColor: '#4A4A4A !important',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#555555 !important',
  },
};

export const StyledCheckbox = {
  color: '#888888 !important',
  padding: '0 !important',

  '&.Mui-checked': {
    color: '#007AFF !important',
  },

  '&:hover': {
    color: '#4A4A4A !important',
  },

  '&.Mui-checked:hover': {
    backgroundColor: 'transparent !important',
    color: '#0066CC !important',
  },

  '&.Mui-disabled': {
    color: '#666666 !important',
  },

  '& .MuiSvgIcon-root': {
    fontSize: '18px !important',
  },
};

export const StyledHelpIcon = styled(HelpOutlineIcon)(({theme}) => ({
  fontSize: '16px',
  color: theme?.palette?.semantic_dark?.surface.onSurfaceMuted,
}));

export const FieldLabel = styled(Box)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
